import React, { useContext } from 'react';
import '../NewCollections/NewCollections.css';
import { FaStar } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { mainImageURI } from '../assets/constants/Urls/Url';
//import ProductRowBgContext from '../../context/ProductRowBgContext';
import { useTheme } from '../assets/context/ThemeContex';

const Card = ({ item }) => {
  const navigate = useNavigate();
  //const productRowBg = useContext(ProductRowBgContext);
  const { theme } = useTheme();

  const truncate = (str, n) =>
    str && str.length > n ? str.slice(0, n - 1) + "…" : str;

  const handleCardClick = (id) => {
    if (id) {
      navigate(`/product/${id}`);
    }
  };

  return (
    <div
      className="card1f dark-card"
      key={item.id}
      onClick={() => handleCardClick(item.id)}
      style={{
        cursor: 'pointer',
        background: `var(--cardBackground)`,
        border: `1px solid var(--cardBorder)`,
        color: `var(--textMain)`
      }}
    >
      <picture>
        <source
          srcSet={`${mainImageURI}${(String(item.id + "_" + 0))
            .replace(/\.(jpg|jpeg|png)$/, '.webp')}/${item.id}`}
          type="image/webp"
        />
        <img
          src={`${mainImageURI}${String(item.id + "_" + 0)}/${item.id}`}
          className="card1-img-top"
          alt={item.product_name}
          loading="lazy"
          style={{
            background: `var(--background)`,
            borderRadius: "1rem 1rem 0 0"
          }}
        />
      </picture>
      <div className="card-body">
        <p className="card-text" style={{ color: "var(--primary)", fontWeight: 600 }}>{`$${item.price}`}</p>
        <div className="stars">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} color={i < item.average_rating ? theme.colors.primary : theme.colors.textMuted} size={15} />
          ))}
        </div>
        <h5
          className="card-title"
          style={{
            color: "var(--textHeading)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            marginBottom: 0,
          }}
          title={item.name}
        >
          {truncate(item.name, 28)}
        </h5>
      </div>
    </div>
  );
};

export default Card;
